import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CollapseBlock } from '../../../../common/index.jsx';
import { useTranslation } from 'react-i18next';
import FormTextField from '../../../../antd/form/FormTextField/FormTextField.jsx';
import DataGrid from '../../../../common/DataGrid/DataGrid.jsx';
import {
  dataGridNumberSorter,
  dataGridTextSorter,
} from '../../../../common/DataGrid/sorters/DataGridSorters.jsx';
import { useDataGridTextFilter } from '../../../../common/DataGrid/filters/useDataGridTextFilter.jsx';

const RoleForm = ({ users, chosenPermissions }) => {
  const { t } = useTranslation();

  const firstNameTextFilterProps = useDataGridTextFilter('first_name');
  const lastNameTextFilterProps = useDataGridTextFilter('last_name');

  const idTextFilterProps = useDataGridTextFilter('id');

  const nameOfPermissionFilterProps = useDataGridTextFilter('name');

  const columnsUsers = useMemo(
    () => [
      {
        title: 'Id',
        dataIndex: 'person_id',
        ellipsis: true,
        key: 'id',
        sorter: dataGridNumberSorter('person_id'),
      },
      {
        title: t('Meno'),
        dataIndex: 'first_name',
        ellipsis: true,
        sorter: dataGridTextSorter('first_name'),
        ...firstNameTextFilterProps,
      },
      {
        title: t('Priezvisko'),
        dataIndex: 'last_name',
        ellipsis: true,
        sorter: dataGridTextSorter('last_name'),
        ...lastNameTextFilterProps,
      },
    ],
    [t, firstNameTextFilterProps, lastNameTextFilterProps],
  );

  const columnsRoles = useMemo(
    () => [
      {
        title: 'Id',
        dataIndex: 'id',
        ellipsis: true,
        key: 'id',
        sorter: dataGridNumberSorter('id'),
        ...idTextFilterProps,
      },
      {
        title: t('Názov'),
        dataIndex: 'name',
        ellipsis: true,
        sorter: dataGridTextSorter('name'),
        ...nameOfPermissionFilterProps,
      },
    ],
    [t, idTextFilterProps, nameOfPermissionFilterProps],
  );

  return (
    <>
      <CollapseBlock title={t('Názov role')}>
        <FormTextField label={t('Názov role')} name="name" disabled={true} />
      </CollapseBlock>

      <CollapseBlock title={t('Oprávnenia role')} collapsible={true}>
        <DataGrid
          rowKey={(data) => data.id}
          columns={columnsRoles}
          dataSource={chosenPermissions || []}
          permissionsBasic="roles"
          uniqueTableId="roles-permissions-table"
          disableSettings={true}
        />
      </CollapseBlock>

      <CollapseBlock title={t('Používatelia s touto rolou')} collapsible={true}>
        <DataGrid
          rowKey={(user) => user.person_id || user.id}
          columns={columnsUsers}
          dataSource={(users || []).map((item) =>
            item.id ? { ...item, person_id: item.id } : item,
          )}
          permissionsBasic="users"
          uniqueTableId="roles-users-table"
          disableSettings={true}
        />
      </CollapseBlock>
    </>
  );
};

RoleForm.propTypes = {
  permissions: PropTypes.array,
  users: PropTypes.array,
  chosenPermissions: PropTypes.array,
  onPermissionDelete: PropTypes.func,
  onUserDelete: PropTypes.func,
  changesMade: PropTypes.bool,
};

export default RoleForm;
